import FileAnalysisStore from 'stores/FileAnalysisStore';
import DriverStore, { IDriver } from 'stores/driver/DriverStore';

export default class DriverListStore extends FileAnalysisStore<DriverStore> {
    constructor() {
        super({
            itemStore: DriverStore,
            baseRoute: 'drivers'
        });
    }

    public get files(): (IDriver | undefined)[] {
        return this.ids.map((id) => {
            const itemStore = this.data.get(id);

            if (itemStore) {
                return {
                    ...itemStore.driver,
                    store: itemStore
                };
            }
        });
    }
}
